import { render, staticRenderFns } from "./LoginWelcome.component.vue?vue&type=template&id=555e75f8&"
import script from "./LoginWelcome.component.vue?vue&type=script&lang=ts&"
export * from "./LoginWelcome.component.vue?vue&type=script&lang=ts&"
import style0 from "./LoginWelcome.component.vue?vue&type=style&index=0&id=555e75f8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports